import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	Img,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

export const ExploreElementsRecording20261027Composition = ({
	cursorFrame,
	showDragPreview,
}: {
	readonly cursorFrame: number | null;
	readonly showDragPreview: boolean;
}) => {
	const {fps} = useVideoConfig();
	const currentFrame = (useCurrentFrame() * 60) / fps;
	const frame = cursorFrame ?? currentFrame;
	const cursorTranslate = interpolate(
		frame,
		[
			1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15, 16, 17, 22, 23, 24, 25,
			26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 118, 119, 120,
			121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135,
			136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150,
			151, 152, 153, 154, 155, 156, 157, 160, 161, 162, 163, 166, 167, 168, 169,
			171, 172, 174, 175, 177, 178, 179, 260, 261, 262, 263, 264, 265, 266, 267,
			268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282,
			283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 298, 299,
			300, 301, 302, 303, 304, 432, 433, 434, 435, 436, 437, 438, 439, 449, 450,
			451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463, 464, 465,
			466, 469, 470, 471, 475, 476, 477, 478, 479, 480, 481, 482, 483, 484, 485,
			486, 487, 488, 489, 490, 491, 492, 493, 494,
		],
		[
			'1694.4375px 3089.2250000000004px',
			'1694.4375px 3089.2250000000004px',
			'1694.4375px 3089.2250000000004px',
			'1694.4375px 3089.2250000000004px',
			'1694.4375px 3089.2250000000004px',
			'1694.4375px 3089.2250000000004px',
			'1694.4375px 3089.2250000000004px',
			'1694.4375px 3089.2250000000004px',
			'1695.6875px 3090.5125000000003px',
			'1700.0875px 3088.6125px',
			'1710.3375px 3085.15px',
			'1716.875px 3084.05px',
			'1716.875px 3084.05px',
			'1716.4750000000001px 3084.4375px',
			'1716.4750000000001px 3084.4375px',
			'1716.2250000000001px 3084.675px',
			'1716.2250000000001px 3084.675px',
			'1718.1625000000001px 3083.7000000000003px',
			'1721.4px 3078.125px',
			'1703.3875px 3035.425px',
			'1607.2px 2922.4px',
			'1355.8500000000001px 2681.5px',
			'919.5625px 2284.475px',
			'538.825px 1942.1000000000001px',
			'284.35px 1721.3875px',
			'189.4625px 1638.875px',
			'136.6125px 1592.1750000000002px',
			'56.5px 1527.8000000000002px',
			'-15.525px 1472.325px',
			'-57.300000000000004px 1436.75px',
			'-70.8375px 1422.2625px',
			'-72.575px 1418.2875000000001px',
			'-82.80000000000001px 1395.3625000000002px',
			'-108.92500000000001px 1356.15px',
			'-164.7375px 1288.2px',
			'-164.7375px 1288.2px',
			'155.2375px 730.825px',
			'155.2375px 730.825px',
			'350.4375px 762.825px',
			'520.0375px 794.825px',
			'561.6375px 801.225px',
			'596.8375px 807.625px',
			'616.0375px 810.825px',
			'638.4375px 814.0250000000001px',
			'660.8375000000001px 814.0250000000001px',
			'686.4375px 817.225px',
			'712.0375px 817.225px',
			'734.4375px 817.225px',
			'744.0375px 817.225px',
			'763.2375000000001px 817.225px',
			'779.2375000000001px 817.225px',
			'795.2375000000001px 820.4250000000001px',
			'808.0375px 820.4250000000001px',
			'830.4375px 820.4250000000001px',
			'843.2375000000001px 820.4250000000001px',
			'856.0375px 820.4250000000001px',
			'856.0375px 820.4250000000001px',
			'884.8375000000001px 820.4250000000001px',
			'891.2375000000001px 820.4250000000001px',
			'900.8375000000001px 820.4250000000001px',
			'907.2375000000001px 823.625px',
			'920.0375px 823.625px',
			'926.4375px 823.625px',
			'942.4375px 823.625px',
			'961.6375px 823.625px',
			'980.8375000000001px 823.625px',
			'987.2375000000001px 823.625px',
			'1000.0375px 823.625px',
			'1003.2375000000001px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1009.6375px 823.625px',
			'1012.075px 824.225px',
			'1012.075px 824.225px',
			'1012.375px 824.5250000000001px',
			'1034.05px 848.3125px',
			'1124.875px 944.9125px',
			'1290.325px 1097.7250000000001px',
			'1290.325px 1097.7250000000001px',
			'1494.025px 1282.6875px',
			'1714.3875px 1504.7375000000002px',
			'1838.1875px 1660.9125000000001px',
			'1933.65px 1836.4px',
			'2013.8125px 1964.7875000000001px',
			'2084.1375000000003px 2072.9500000000003px',
			'2105.5750000000003px 2111.15px',
			'2123.2125px 2144.4px',
			'2133.6875px 2161.375px',
			'2139.7000000000003px 2166.4875px',
			'2146.7875px 2170.275px',
			'2157.375px 2173px',
			'2160.0875px 2173.2375px',
			'2164.525px 2172.0375px',
			'2171.9125px 2168.4125px',
			'2180.0375px 2164.4875px',
			'2192.4875px 2161.425px',
			'2218.525px 2157.2375px',
			'2248.6px 2151.7875px',
			'2282.7625000000003px 2141.225px',
			'2304.8625px 2129.8125px',
			'2335.8px 2109.4375px',
			'2349px 2099.6625px',
			'2356.4px 2092.6875px',
			'2364.675px 2084.725px',
			'2367.8250000000003px 2078.9125px',
			'2371.125px 2072.2875px',
			'2373.0750000000003px 2066.8125px',
			'2373.7125px 2063.65px',
			'2373.7375px 2063.375px',
			'2373.7375px 2063.375px',
			'2373.7375px 2062.9625px',
			'2373.7375px 2062.1px',
			'2373.7375px 2061.3875000000003px',
			'2373.7375px 2060.675px',
			'2373.7375px 2060.375px',
			'2373.7375px 2060.35px',
			'2373.7375px 2060.35px',
			'2372.6125px 2059.9px',
			'2371.375px 2059.4px',
			'2369.6375000000003px 2058.8250000000003px',
			'2369.6375000000003px 2058.8250000000003px',
			'2369.6375000000003px 2058.8250000000003px',
			'2369.6375000000003px 2058.8250000000003px',
			'2369.6375000000003px 2058.8250000000003px',
			'2369.6375000000003px 2058.8250000000003px',
			'2369.9125px 2060.125px',
			'2370.725px 2060.9375px',
			'2370.725px 2060.9375px',
			'2373.2125px 2062.9875px',
			'2371.925px 2063.8875000000003px',
			'2367.975px 2066.9500000000003px',
			'2347.775px 2090.3px',
			'2305.4375px 2151.025px',
			'2178.3px 2348.5625px',
			'2025.075px 2565.5px',
			'1898.325px 2733.7000000000003px',
			'1784.7px 2876.4px',
			'1728.9250000000002px 2938.1125px',
			'1679.3625000000002px 2982.7000000000003px',
			'1627.3875px 3013.65px',
			'1599.5875px 3028.3875000000003px',
			'1584.0500000000002px 3035.925px',
			'1584.0500000000002px 3035.925px',
			'1584.0500000000002px 3035.6875px',
			'1584.0500000000002px 3035.4375px',
			'1584.0500000000002px 3035.4375px',
			'1585.4750000000001px 3036.5625px',
			'1599.075px 3047.4125000000004px',
			'1621.5375000000001px 3064.5375000000004px',
			'1639.2125px 3075.875px',
			'1653.4875000000002px 3080.4125000000004px',
			'1666.25px 3084.0125000000003px',
			'1671.95px 3086.1625000000004px',
			'1674.825px 3087.9px',
			'1678.2875000000001px 3090.9px',
			'1685.4250000000002px 3097.5px',
			'1690.0125px 3102.15px',
			'1694.4125000000001px 3107.2125px',
			'1698.3625000000002px 3112.75px',
			'1701.6750000000002px 3118.275px',
			'1702.5125px 3122.4375px',
			'1702.6625000000001px 3127.8500000000004px',
			'1702.9750000000001px 3132.8875000000003px',
			'1703.025px 3135.8875000000003px',
			'1703.025px 3136.3375px',
		],
		{
			extrapolateLeft: 'clamp',
			extrapolateRight: 'clamp',
		},
	);

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(562 / 60) * fps}
			style={{
				width: 2402,
				height: 1600,
			}}
		>
			<Video
				src="https://remotion.media/explore-remotion/elements-source-2026-10-27-ad41f4dc2cf1.mp4"
				durationInFrames={(562 / 60) * fps}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					width: 2402,
					height: 1600,
				}}
			/>
			{showDragPreview && currentFrame >= 119 && currentFrame < 179 ? (
				<Img
					src="https://remotion.media/elements/backgrounds-rotating-starburst-preview.png"
					style={{
						position: 'absolute',
						// Match the 132 × 74.25 CSS-pixel drag image and its centered
						// hotspot at the recording's 3.2× capture density.
						width: 132 * 3.2,
						height: 74.25 * 3.2,
						left: -66 * 3.2,
						top: -37.125 * 3.2,
						translate: cursorTranslate,
						opacity: 0.75,
					}}
				/>
			) : null}
			<MacOSCursor
				cursor={interpolate(
					frame,
					[1, 264, 266, 267, 269, 272, 289, 433],
					[
						'auto',
						'default',
						'text',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 305, 313, 495, 502],
						[3.2, 2.8800000000000003, 3.2, 2.8800000000000003, 3.2],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: cursorTranslate,
				}}
			/>
		</AbsoluteFill>
	);
};
